export const DECLARATION_FILTERS = {
  all: 'all',
  validated: 'validated',
  refused: 'refused',
  waiting: 'waiting',
} as const;
